export const ONE_MINUTE = 60
export const FULL_TIMER = 120
export const MILLISECONDS_MULTIPLIER = 1000
